import React from "react";
import { LoginPageContextProvider } from "./LoginPageView";
import { LoginPage } from "./views/LoginPage";

export const Login = () => {
  return (
    <>
      <LoginPageContextProvider>
        <LoginPage />
      </LoginPageContextProvider>
    </>
  );
};
